import { useLocalStorage } from 'usehooks-ts';

export type TrackedOrder = {
    id: string;
    isCompleted: boolean;
};

export const useTrackedOrders = () => {
    return useLocalStorage<TrackedOrder[]>('tracked-orders', []);
};
